import React from 'react';
import { FaPhone, FaEnvelope, FaWhatsapp, FaFacebook, FaLinkedin } from 'react-icons/fa';
import { BsTwitterX, BsYoutube } from "react-icons/bs";
import Mainmastet from '../masterpage/Mainmastet';

const ContactPage = () => {
  const phoneNumber = '0101123022';
  const email = 'info@ziditech.co.ke';
  const whatsappNumber = '254101123022';
  const twitterHandle = 'ZidiTech';
  const facebookProfile = '100069411789655';
  const youtubeChannel = '@ZidiTechnologies';
  const linkedIn = "zidi-technologies";

  const styles = {
    container: {
      padding: '50px 20px',
      maxWidth: '900px',
      margin: '0 auto',
      backgroundColor: '#f9f9f9',
      borderRadius: '12px',
      boxShadow: '0 6px 15px rgba(0, 0, 0, 0.1)',
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    },
    heading: {
      fontSize: '40px',
      marginBottom: '40px',
      color: '#222',
      textAlign: 'center',
      fontWeight: 'bold',
    },
    list: {
      listStyle: 'none',
      padding: 0,
      display: 'flex',
      flexDirection: 'column',
      gap: '25px',
    },
    listItem: {
      display: 'flex',
      alignItems: 'center',
      padding: '15px 20px',
      borderRadius: '10px',
      backgroundColor: '#fff',
      boxShadow: '0 4px 10px rgba(0,0,0,0.05)',
      transition: 'all 0.3s ease',
    },
    listItemHover: {
      transform: 'translateY(-3px)',
      boxShadow: '0 6px 14px rgba(0,0,0,0.15)',
    },
    icon: {
      fontSize: '28px',
      marginRight: '15px',
      color: '#007BFF',
    },
    details: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
    label: {
      fontSize: '16px',
      fontWeight: '600',
      color: '#333',
    },
    value: {
      fontSize: '15px',
      color: '#555',
      marginTop: '3px',
      textDecoration: 'none',
      transition: 'color 0.3s',
    },
    valueHover: {
      color: '#007BFF',
    },
    '@media (max-width: 768px)': {
      heading: {
        fontSize: '28px',
      },
      listItem: {
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
      },
      details: {
        alignItems: 'center',
      },
    }
  };

  const [hoveredItem, setHoveredItem] = React.useState(null);

  const items = [
    { icon: <FaPhone style={styles.icon} />, label: 'Phone', value: phoneNumber, href: `tel:${phoneNumber}` },
    { icon: <FaEnvelope style={styles.icon} />, label: 'Email', value: email, href: `mailto:${email}` },
    { icon: <FaWhatsapp style={{ fontSize: '28px', color: 'green', marginRight: '15px' }} />, label: 'WhatsApp', value: `+${whatsappNumber}`, href: `https://wa.me/${whatsappNumber}` },
    { icon: <BsTwitterX style={{ fontSize: '28px', color: 'black', marginRight: '15px' }} />, label: 'Twitter', value: `@${twitterHandle}`, href: `https://twitter.com/${twitterHandle}` },
    { icon: <FaFacebook style={{ fontSize: '28px', color: '#1877f2', marginRight: '15px' }} />, label: 'Facebook', value: 'ZidiTech', href: `https://facebook.com/${facebookProfile}` },
    { icon: <BsYoutube style={{ fontSize: '30px', color: 'red', marginRight: '15px' }} />, label: 'YouTube', value: youtubeChannel, href: `https://www.youtube.com/${youtubeChannel}` },
    { icon: <FaLinkedin style={{ fontSize: '30px', color: '#0a66c2', marginRight: '15px' }} />, label: 'LinkedIn', value: 'Zidi Technologies', href: `https://www.linkedin.com/company/${linkedIn}/` },
  ];

  return (
    <Mainmastet content={
      <div style={styles.container}>
        <h1 style={styles.heading}>Get in Touch</h1>
        <ul style={styles.list}>
          {items.map((item, index) => (
            <li
              key={index}
              style={{ ...styles.listItem, ...(hoveredItem === index ? styles.listItemHover : {}) }}
              onMouseEnter={() => setHoveredItem(index)}
              onMouseLeave={() => setHoveredItem(null)}
            >
              {item.icon}
              <div style={styles.details}>
                <span style={styles.label}>{item.label}</span>
                <a 
                  href={item.href} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  style={{ 
                    ...styles.value, 
                    ...(hoveredItem === index ? styles.valueHover : {}) 
                  }}
                >
                  {item.value}
                </a>
              </div>
            </li>
          ))}
        </ul>
      </div>
    } />
  );
};

export default ContactPage;
